import { createSlice } from "@reduxjs/toolkit";
import {
  toCheckMyListBalance,
  toGetHyperPayKeys,
  toGetMylistKeys,
  toGetTabbyKeys,
  toGetYougotaGiftKeys,
} from "../actions/paymentMethods.actions";

const initialState = {
  tabbyKeys: {
    list: [],
    status: "",
  } as any,
  myListKeys: {
    data: {},
    status: "",
  } as any,
  myListCheckBalance: {
    data: {},
    status: "",
  } as any,
  HyperPayKeys: {
    data: {},
    status: "",
  } as any,
  YougotaGiftKeys: {
    keys: {},
    status: "",
  } as any,
  loading: false,
  error: null as unknown | null,
};
export const tabbySlice = createSlice({
  name: "tabbyKeys",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(toGetTabbyKeys.pending, (state) => {
      state.tabbyKeys = { list: [], status: "idle" };
    });
    builder.addCase(toGetTabbyKeys.fulfilled, (state, action) => {
      state.tabbyKeys = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetTabbyKeys.rejected, (state, action) => {
      state.tabbyKeys = { list: [], status: "rejected" };
      state.error = action.payload;
    });
    // to get my list keys
    builder.addCase(toGetMylistKeys.pending, (state) => {
      state.myListKeys = { data: {}, status: "idle" };
    });
    builder.addCase(toGetMylistKeys.fulfilled, (state, action) => {
      state.myListKeys = { data: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetMylistKeys.rejected, (state, action) => {
      state.myListKeys = { data: {}, status: "rejected" };
      state.error = action.payload;
    });
    // to check balance for my list
    // to get my list keys
    builder.addCase(toCheckMyListBalance.pending, (state) => {
      state.myListCheckBalance = { data: {}, status: "idle" };
    });
    builder.addCase(toCheckMyListBalance.fulfilled, (state, action) => {
      state.myListCheckBalance = {
        data: action.payload.data,
        status: "succedded",
      };
    });
    builder.addCase(toCheckMyListBalance.rejected, (state, action) => {
      state.myListCheckBalance = { data: {}, status: "rejected" };
      state.error = action.payload;
    });
    // to get hyperPay keys
    builder.addCase(toGetHyperPayKeys.pending, (state) => {
      state.HyperPayKeys = {
        keys: state.HyperPayKeys?.keys ?? {},
        status: "loading",
      };
    });
    builder.addCase(toGetHyperPayKeys.fulfilled, (state, action) => {
      state.HyperPayKeys = { keys: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetHyperPayKeys.rejected, (state, action) => {
      state.HyperPayKeys = { keys: {}, status: "rejected" };
      state.error = action.payload;
    });
    // to get you gotagift keys
    builder.addCase(toGetYougotaGiftKeys.pending, (state) => {
      state.YougotaGiftKeys = { data: {}, status: "idle" };
    });
    builder.addCase(toGetYougotaGiftKeys.fulfilled, (state, action) => {
      state.YougotaGiftKeys = {
        data: action.payload.data,
        status: "succedded",
      };
    });
    builder.addCase(toGetYougotaGiftKeys.rejected, (state, action) => {
      state.YougotaGiftKeys = { data: {}, status: "rejected" };
      state.error = action.payload;
    });
  },
});

export default tabbySlice.reducer;
